<script>
  import { useLocation, Link as NavLink } from "svelte-navigator";
  import { locale, locales, _ } from 'svelte-i18n'
  import { isMenuActive, isMeditationOn } from '/stores.js';
  import { styleVars } from '/helper'
  import { onAlmanac } from '/routes'

  import Link from '/Atoms/Link'
  import IconClose from '/Icons/IconClose'

  export let zIndex, easy, initial = false // easy means no weird filters

  const show_language_menu = true //process.env.SHOW_PENDING
  //console.log("show_language_menu", show_language_menu)

  const onMenu = () => { $isMenuActive = !$isMenuActive }
  const onSilence = () => { $isMeditationOn = !$isMeditationOn }
  const exit = () => { $isMenuActive = false }

  const location = useLocation();

  let showSilenceButton = false
  let showTransmediale = false
  let germanPath, englishPath

  $: {
    $location && exit() // exit menu whenever there is a route change

    germanPath = '/de' + $location.pathname
    englishPath = $location.pathname == "/de" ? "/" : $location.pathname.substring(3)

    showSilenceButton = !onAlmanac($location.pathname)
    showTransmediale = !$isMeditationOn
  }

</script>

<div class:initial class:easy class:silence={$isMeditationOn} class:active={$isMenuActive} class="toggler" style={styleVars({ zIndex: parseInt(zIndex)+1 })}>
  <div class="icon-close">
    <IconClose black />
  </div>
  <div class="menu-text">
    Menu
  </div>
  <div class="toggle-menu" on:click={onMenu} class:hide={$isMeditationOn}></div>
  {#if showSilenceButton}
    <div class="toggle-silence" on:click={onSilence}></div>
  {/if}
</div>

{#if showTransmediale}
  <h1 class:initial class:nosilence={!showSilenceButton} class="transmediale" class:active={$isMenuActive} style={styleVars({ zIndex: parseInt(zIndex)+2 })}>
    <Link to="/" hover="none">transmediale</Link>
  </h1>
{/if}

<nav id="main_nav" class:active={$isMenuActive} style={styleVars({ zIndex })} on:click={exit}>
  <ol>
    <li>
      <Link to="theme" >{$_('menu.theme')}</Link>
    </li>
    <li>
      <Link to="programme" >{$_('menu.programme')}</Link>
    </li>
    <li>
      <Link to="artists" >{$_('menu.artists')}</Link>
    </li>
    <li>
      <Link to="visit" >{$_('menu.visit')}</Link>
    </li>
    <li>
      <Link to="about" >{$_('menu.about')}</Link>
    <li>
  </ol>
</nav>

<nav id="secondary_nav" class:active={$isMenuActive} style={styleVars({ zIndex })}>
  <ul>
    <li>
      <Link to="/press">
        Press
      </Link>
    </li>
    <li>
      <Link to="/supporters">
        Supporters
      </Link>
    </li>
    <li>
      <Link to="https://transmediale.myshopify.com/">
        Online Shop
      </Link>
    </li>
  </ul>
</nav>

{#if show_language_menu}
<nav id="language_nav" class:active={$isMenuActive} style={styleVars({ zIndex })}>
  <ul>
    <li class:hidden={ $locale === "de"}>
      <NavLink to={germanPath} >
        Deutsch
      </NavLink>
    </li>
    <li class:hidden={ $locale === "en"}>
      <NavLink to={englishPath} >
        English
      </NavLink>
    </li>
  </ul>
</nav>
{/if}

<style lang="scss">

  .toggler, .transmediale {
    position: fixed;
    z-index: var(--zIndex);
  }

  .toggler {
    mix-blend-mode: difference;
    &.easy {
      mix-blend-mode: normal;
    }

    transition: all 1s;

    display: inline-flex;
    
    left: 20px;
    top: 20px;
    
    @include media-small {
      left: 10px;
      top: 10px;
    }
    
    &.active {
      /*position: absolute;*/
      mix-blend-mode: normal;
    }

    opacity: 1;
    &.initial {
      opacity: 0;
    }
  }

  .transmediale {
    left: calc( 130px + 160/800 * 100vw); // 160px when 100vw==800px , 240px when 100vw==1200px;
    &.nosilence {
      left: calc( 130px - 80px + 160/800 * 100vw); // 160px when 100vw==800px , 240px when 100vw==1200px;
    }
    top: 20px;
    line-height: 60px;
    text-shadow: $shadow;

    filter: blur(1.5px); // figma: 4px
    &:hover {
      filter: blur(0px);
    }

    @include media-small {
      left: 250px;
      line-height: 40px;
      top: 12px;
      &.nosilence {
        left: 190px;
      }
    }

    @include media-menu-maxout {
      left: 130px + 240px;
      &.nosilence {
        left: 50px + 240px;
      }
    }

    @include media-menu-xs {
      left: 160px;
      &.nosilence {
        left: 110px;
      }
    }

    transition: left 2s;
    &.initial {
      left: 5vw;
    }

    &, a {
      display:block;
      color: $color-white;
      @include typo-grotesk-title-transmediale;
    }


    &.active, &.active a {
      color: $color-mint;
    }
  }

  .toggle-menu, .toggle-silence {
    display: inline-block;
    background-color: $color-mint;
    user-select: none;

    height: 60px;
    border-radius: 30px;
    filter: blur(10px); // figma: 15px
    @include media-small {
      filter: blur(8px); // figma: 12px
      height: 40px;
      border-radius: 20px;
    }

    &:hover {
      cursor: pointer;
    }

    &.hide {
      visibility: hidden;
    }
  }

  .toggle-menu {
    width: calc(160/800 * 100vw); // 160px when 100vw==800px , 240px when 100vw==1200px
    min-width: 160px;
    max-width: 240px;

    @include media-menu-xs {
      width: 80px;
      min-width: 80px;
    }
  }

  .icon-close, .menu-text {
    /* TODO make dry, same as toggler */

    width: calc(160/800 * 100vw); // 160px when 100vw==800px , 240px when 100vw==1200px
    min-width: 160px;
    max-width: 240px;
    height: 60px;

    @include media-small {
      height: 40px;
    }

    @include media-menu-xs {
      width: 80px;
      min-width: 80px;
    }

    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    pointer-events: none;
    position: absolute;
    z-index: 100;
    @include typo-grotesk-title-captions-20;

    .silence & {
      display: none;
    }
  }

  .icon-close {
    opacity: 0;
    transition: 1s;
    .active & {
      opacity: 1;
    }
  }

  .menu-text {
    opacity: 0;

    &:hover {
      opacity: 1;
    }

    .easy & {
      opacity: 1;
    }

    .active & {
      opacity: 0;
    }
  }



  .toggle-silence {
    width: 60px;
    margin-left: 20px;
    @include media-small {
      width: 40px;
      margin-left: 10px;
    }
  }

  nav:not(.active) {
    display: none;
    pointer-events: none;
  }

  #main_nav {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #F2F2F2f0;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: var(--zIndex);
    backdrop-filter: blur(5px);
  }

  #secondary_nav {
    position: fixed;
    z-index: var(--zIndex);

    left: 20px;
    bottom: 20px;
    @include media-small {
      left: 10px;
      bottom: 14px;
    }
    &:not(.active) {
      display: none;
    }

    ul {
      display: inline-flex;
      flex-direction: row;
      li:not(:last-child) {
        padding-right: 1em;
      }
    }
  }

  #language_nav {
    position: fixed;
    z-index: var(--zIndex);

    right: 20px;
    top: 20px;
    @include media-small {
      right: 10px;
      top: 14px;
    }
    &:not(.active) {
      display: none;
    }

    ul {
      display: inline-flex;
      flex-direction: row;
      li:not(:last-child) {
        padding-right: 1em;
      }
    }
  }

  ol {
    @include typo-grotesk-title-100;

    font-size: 13vmin !important;
    line-height: 13vmin !important;
    :global(a) {
      text-align: center;
      display: inline-block;
      width: 100%;
    }
  }
  #main_nav:not(.active) {
    display: none;
  }

  li {
    pointer-events: all;
    &:hover {
      color: $color-mint;
    }
  }

  :global(#main_nav a, a:hover, a:active) {
    text-decoration: none;
  }

  #secondary_nav, #language_nav {
    @include typo-grotesk-text-24;
  }

  #language_nav {
    .hidden {
      display:none;
    }
    li {
      padding-right: 0 !important;
      span {
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

</style>
